import useBookingAnalytics from "@/hooks/useBookingAnalytics";
import { Button, FAIconName } from "@/ui/core";
import { Box } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface EditEventButtonProps {
  eventId: string;
  isGroupClassEvent: boolean;
  isRecurring?: boolean;
  onPress: () => void;
}

const EditEventButton = ({
  eventId,
  isGroupClassEvent,
  isRecurring,
  onPress,
}: EditEventButtonProps) => {
  const title = isGroupClassEvent ? "Edit registration" : "Edit appointment";
  const testIdEvent = isGroupClassEvent ? "group-class" : "appointment";

  const { trackEditEventPress } = useBookingAnalytics();

  const handlePress = () => {
    trackEditEventPress({
      eventId,
      isGroupClassEvent,
      isRecurring,
    });
    onPress();
  };

  return (
    <Box paddingTop={20}>
      <Button
        leftIcon={FAIconName.Pen}
        onPress={handlePress}
        size="small"
        testID={joinTestIDs("edit", testIdEvent, eventId)}
        title={title}
        variant="secondary"
      />
    </Box>
  );
};

export type { EditEventButtonProps };
export default EditEventButton;
